import { cn } from "@/lib/utils";

interface PageLoaderProps {
  text?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const PageLoader = ({ text, className, size = "md" }: PageLoaderProps) => {
  const dotSizes = {
    sm: "h-1.5 w-1.5",
    md: "h-2 w-2",
    lg: "h-3 w-3",
  };

  return (
    <div className={cn(
      "flex h-full min-h-[200px] w-full flex-col items-center justify-center gap-4",
      className
    )}>
      <div className="flex items-center gap-1.5">
        <div 
          className={cn(
            "rounded-full bg-primary animate-pulse-dot",
            dotSizes[size]
          )} 
          style={{ animationDelay: "0ms" }}
        />
        <div 
          className={cn(
            "rounded-full bg-primary animate-pulse-dot",
            dotSizes[size]
          )} 
          style={{ animationDelay: "150ms" }}
        />
        <div 
          className={cn(
            "rounded-full bg-primary animate-pulse-dot",
            dotSizes[size]
          )} 
          style={{ animationDelay: "300ms" }}
        />
      </div>
      {text && (
        <p className="text-sm text-muted-foreground animate-fade-in">{text}</p>
      )}
    </div>
  );
};

export const FullPageLoader = ({ text = "Loading..." }: { text?: string }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in">
      <PageLoader text={text} size="lg" />
    </div>
  );
};
